import { Injectable } from '@angular/core';
import { CnpjDataService } from './cnpj-data.service';
import { CnpjModel } from 'src/app/shared/service/cnpj/model/cnpj.model';
import { HandlerService } from '../comunicator-native/handler/handler';

@Injectable({
  providedIn: 'root'
})
export class CnpjDataMobileService implements CnpjDataService{

  constructor(private handlerService: HandlerService) {}

  public getCnpj(cnpjId: string): Promise<CnpjModel> {
    const relCaronte = 'aberturaconta-valida-pessoa-juridica';
    const dataCaronte = { cnpj: cnpjId.toString() };
    return this.handlerService.caronteCommunicator(relCaronte, dataCaronte, null).then((data: any) => {
      if (data && data.data) {
        console.log("teste cnpj full response", data)
        console.log("teste cnpj", data.data)
        return Promise.resolve(data.data);
      } else {
        console.log("caiu no else", data)

        return Promise.resolve();
      }
    });
  }
}

